export default {
      id: "male-usage",
      viewBox: "0 0 10 26",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#male",
      toString: function () {
        return this.url;
      }
    }